import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { logoApple, logoGooglePlaystore } from 'ionicons/icons';
import './MinimumScreenSize.css';
import { Trans } from 'react-i18next';

const MinimumScreenSize: React.FC = () => {
  const handlePlayStoreClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.spinnax.spinnaxfreak', '_blank');
  };

  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/de/app/spinnax-freak/id6443473553', '_blank');
  };

  return (
    <div className="minimum-screen-container">
      {/* Background Image */}
      <div className="minimum-screen-background"></div>
      
      {/* Content Overlay */}
      <div className="minimum-screen-content">
        <div className="minimum-screen-message">
          <h1 className="minimum-screen-title">
            <Trans i18nKey="MINIMUM_SCREEN_TITLE">
              FREAK Mobile App
            </Trans>
          </h1>
          
          <p className="minimum-screen-subtitle">
            <Trans i18nKey="MINIMUM_SCREEN_SUBTITLE">
              For the best experience, please use our mobile app
            </Trans>
          </p>
          
          <p className="minimum-screen-description">
            <Trans i18nKey="MINIMUM_SCREEN_DESCRIPTION">
              This web version is optimized for larger screens (800x600 and above).
              For smaller screens, download our mobile app for the full FREAK experience.
            </Trans>
          </p>
          
          {/* App Store Buttons */}
          <div className="minimum-screen-buttons">
            <IonButton
              fill="solid"
              color="dark"
              size="large"
              className="store-button"
              onClick={handlePlayStoreClick}
            >
              <IonIcon icon={logoGooglePlaystore} slot="start" />
              <div className="button-text">
                <span className="button-subtitle">Get it on</span>
                <span className="button-title">Google Play</span>
              </div>
            </IonButton>
            
            <IonButton
              fill="solid"
              color="dark"
              size="large"
              className="store-button"
              onClick={handleAppStoreClick}
            >
              <IonIcon icon={logoApple} slot="start" />
              <div className="button-text">
                <span className="button-subtitle">Download on the</span>
                <span className="button-title">App Store</span>
              </div>
            </IonButton>
          </div>
          
          {/* Desktop Access Info */}
          <p className="minimum-screen-desktop-info">
            <Trans i18nKey="MINIMUM_SCREEN_DESKTOP_INFO">
              For desktop access, please use a screen resolution of at least 800x600 pixels.
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MinimumScreenSize;
